import { render, staticRenderFns } from "./ResetLoginAccount.vue?vue&type=template&id=d8208f6a&scoped=true&"
import script from "./ResetLoginAccount.vue?vue&type=script&lang=js&"
export * from "./ResetLoginAccount.vue?vue&type=script&lang=js&"
import style0 from "./ResetLoginAccount.vue?vue&type=style&index=0&id=d8208f6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8208f6a",
  null
  
)

export default component.exports